var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[_c('div',{style:({ height: (_vm.height + "px"), width: _vm.width ? (_vm.width + "px") : 'auto' }),attrs:{"id":_vm.chartId},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }